<template>
  <v-hover :value="false" :disabled="!$store.state.roles.includes('webmaster')" v-slot:default="{ hover }">
    <v-card class="rounded-card elevation-10">
      <v-sheet
        class="gradient"
      >
        <v-container fill-height fluid pl-4 pa-2>
          <v-layout fill-height>
            <v-flex xs11 align-end flexbox>
              <span class="text-h6 white--text"><span class="font-weight-light">{{headline}}{{title}}</span></span>
            </v-flex>
            <v-flex xs1 class="text-right">
              <v-icon v-if="hover" right dark v-on:click.stop @click.exact="showEditor = true">edit</v-icon>
              <v-icon v-if="popDialog" right dark v-on:click.stop @click.exact="closeDialog()">close</v-icon>
            </v-flex>
          </v-layout>
        </v-container>
      </v-sheet>
      <v-card-text>
        <div :class="multiColumn" v-if="!showEditor && popDialog" v-html="announcement"/>
        <div class="black--text" v-if="!showEditor && !popDialog" v-html="announcement"/>
        <Editor api-key="2ok38ee479iqsfzkkik6rr7zgctyr025npz221pbsei5hy4t"
          v-if="showEditor"
          :init="{automatic_uploads: true, images_upload_handler: uploadHandler, images_upload_url: website + '/memberlogin2/upload2.php', paste_data_images: true, browser_spellcheck:true, valid_children: '+body[style],+button[type|class]', extended_valid_elements: 'button[type|class],script[language|type]', menubar: false, plugins: ['link','lists','image','code','wordcount','paste'], 'toolbar':'undo redo | formatselect | bold italic | align | link image | numlist bullist code'}"
          v-model="announcement"
        />
      </v-card-text>
      <v-card-actions v-if="showEditor">
        <v-spacer></v-spacer>
        <v-btn autofocus rounded outlined small v-if="showEditor" color="cancel" text @click.exact="cancel">Cancel</v-btn>
        <v-btn rounded small color="primary" @click.exact="save">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import { TokenService } from '@/services/storage.service'

export default {
  name: 'NewsCard',
  components: {
    Editor,
  },
  data: function () {
    return {
      announcement: '',
      originalAnnouncement: '',
      showEditor: false,
      showEditIcon: false,
      multiColumn: '',
      headline: ''
    }
  },
  computed: {
    website: function () {
      return process.env.VUE_APP_WEBSITE
    }
  },
  props: {
    text: String,
    type: String,
    popDialog: {
      type: Boolean,
      default: false
    },
    title: String
  },
  watch: {
    text: function (val) {
      this.announcement = val
      this.originalAnnouncement = val
    },
    type: function (val) {
      this.loadAnnouncement()
    },
    title: function (newTitle) {
      this.headline = newTitle
    }
  },
  mounted () {
    if( this.popDialog ) {
      this.loadAnnouncement()
    }
  },
  methods: {
    uploadHandler (blobInfo, success, failure) {
      var xhr, formData

      xhr = new XMLHttpRequest()
      xhr.withCredentials = false
      xhr.open('POST', this.website + '/memberlogin2/upload2.php')

      xhr.onload = function () {
        var json

        if (xhr.status !== 200) {
          failure('HTTP Error: ' + xhr.status)
          return
        }

        json = JSON.parse(xhr.responseText)

        if (!json || typeof json.file_path !== 'string') {
          failure('Invalid JSON: ' + xhr.responseText)
          return
        }

        success(json.file_path)
      }

      formData = new FormData()
      formData.append('Filedata[]', blobInfo.blob(), blobInfo.filename())
      formData.append('token', TokenService.getToken())
      formData.append('Username', TokenService.getUsername())
      formData.append('tinymce', 'true')
      formData.append('uploadWhere', 'files')

      xhr.send(formData)
    },
    cancel () {
      this.showEditor = false
      this.announcement = this.originalAnnouncement
    },
    closeDialog () {
      this.$emit('close-dialog')
    },
    loadAnnouncement () {
      this.announcement = ''
      this.originalAnnouncement = ''
      axios({ method: 'GET',
        'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_getNews.php?type=' + this.type
      }).then(result => {
        this.announcement = result.data.description
        this.headline = result.data.title
        this.multiColumn = 'black--text ' + result.data.multiColumn
        this.originalAnnouncement = result.data.description
      }, error => {
        console.error(error)
      })
    },
    save () {
      this.showEditor = false
      var params = new URLSearchParams()
      params.append('type', this.type)
      params.append('Username', TokenService.getUsername())
      params.append('token', TokenService.getToken())
      params.append('announcement', this.announcement)
      axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_updateNews.php', params).then(result => {
      }, error => {
        alert('You are not authorized to update news')
        console.error(error)
      })
    }
  }
}
</script>

<style scoped>
.newspaper {
  -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
  -moz-column-gap: 40px; /* Firefox */
  column-gap: 40px;
  -webkit-column-rule: 1px solid lightgrey; /* Chrome, Safari, Opera */
  -moz-column-rule: 1px solid lightgrey; /* Firefox */
  column-rule: 1px solid lightgrey;
}
@media all and (min-width: 600px) {
  .newspaper {
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
  }
}
@media all and (min-width: 900px) {
  .newspaper {
    -webkit-column-count: 3; /* Chrome, Safari, Opera */
    -moz-column-count: 3; /* Firefox */
    column-count: 3;
  }
}

.newspaper2 {
  -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
  -moz-column-gap: 40px; /* Firefox */
  column-gap: 40px;
  -webkit-column-rule: 1px solid lightgrey; /* Chrome, Safari, Opera */
  -moz-column-rule: 1px solid lightgrey; /* Firefox */
  column-rule: 1px solid lightgrey;
}
@media all and (min-width: 600px) {
  .newspaper2 {
    -webkit-column-count: 1; /* Chrome, Safari, Opera */
    -moz-column-count: 1; /* Firefox */
    column-count: 1;
  }
}
@media all and (min-width: 900px) {
  .newspaper2 {
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
  }
}
.gradient {
  background: linear-gradient(180deg, #555555 0%,#555555 100%);
}
</style>
